import { NotificationsLevel } from "../../../../../lib/enums";
import { show } from "../../../../../notifications/notifications";
import { isLocaleAvailableForPlatform } from "../../../../../utils";
import { TEST_CONNECTION_MAP } from "../../../../integrations/consts";
import {
  IntegrationType,
  IReanalyzeSample,
  IReanalyzeValues
} from "../../../@types";
import { InteractiveParams, RlcsParams } from "../reanalyze-form";
import { INTEGRATIONS } from "./consts";

export const getLocaleForPlatform = (locale?: string, platform?: string) =>
  isLocaleAvailableForPlatform(platform) ? locale : undefined;

export const prepareDataForApi = (
  values: IReanalyzeValues,
  rlcsParams: RlcsParams,
  interactiveParams: InteractiveParams,
  samples: IReanalyzeSample[]
) => {
  const tools: Array<IntegrationType> = Object.keys(values)
    .filter(key => values[key as keyof typeof values])
    .map(key => key as IntegrationType);

  const { locale, platform } = rlcsParams ?? {};

  const interactive = Object.entries(interactiveParams).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [`interactive_${key}`]: value
    }),
    {}
  );

  return {
    integrations: tools,
    samples,
    ...rlcsParams,
    ...(!values.local_only && interactive),
    locale: getLocaleForPlatform(locale, platform)
  };
};

const showIntegrationConnectionError = (integrationKey: string) => {
  show({
    level: NotificationsLevel.ERROR,
    message: `${
      INTEGRATIONS[integrationKey as keyof typeof INTEGRATIONS]
    } integration is currently unavailable. Try again in a few minutes or check with your admin if the integration is correctly configured.`
  });
};

export const checkIntegrationConnectivity = async (integrationKey: string) => {
  const checkConnectionStatus =
    TEST_CONNECTION_MAP[integrationKey as keyof typeof TEST_CONNECTION_MAP];
  try {
    await checkConnectionStatus();
  } catch (error) {
    // prevent submission only if we are sure that the integration API is unreachable
    if (error.data?.detail?.api) {
      showIntegrationConnectionError(integrationKey);
      return false;
    }
  }
  return true;
};
